import { api } from "./api.js";

// Bruecke zur Median-Huelle (Statusleiste, OneSignal). Median ruft
// window.median_library_ready() auf, sobald seine Bibliothek bereit ist;
// nach dem Login rufen wir es selbst, damit das Geraet registriert wird.
export function installMedianBridge(app) {
    window.median_library_ready = function () {
        const median = window.median;
        if (!median) return;

        median.statusbar.set({ style: "light", color: "00000000", overlay: true, blur: false });

        median.onesignal.onesignalInfo().then(function (oneSignalInfo) {
            api.post("/frontend/helper/onesignal/register", oneSignalInfo).catch(() => {});
        });
    };

    if (window.median) window.median_library_ready();
}
